import { render, staticRenderFns } from "./foruminf.vue?vue&type=template&id=ce94366a"
import script from "./foruminf.vue?vue&type=script&lang=js"
export * from "./foruminf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports